import { PAGINATION_LIMIT } from '@saucelabs/sl-util-config';
import { actions as notificationActions } from '@saucelabs/sl-container-notifications';
import { helpers as tableHelpers } from '@saucelabs/sl-component-tables';

import * as api from './api';
import * as actions from './actions';
import { actions as teamsActions } from './../../ducks/teams';
import {
  actions as activityActions,
  constants as activityConstants,
  utils as activityUtils,
} from './../../ducks/activity';
import { TEAM_TABLE } from '../../constants';
import { operations as devicesOperations } from '../devices';

export const getInitialTeamTable = () => (dispatch, getState) => {
  dispatch(actions.getInitialTeamTableRequest());
  const ordering = tableHelpers.serializeSorting(getState().table?.sorting?.[TEAM_TABLE.TABLE_NAME]).join(',') || undefined;
  return dispatch(teamsActions.getTeamList({ ordering }))
    .then(({ data }) => {
      const teamIds = data.results.map((team) => team.id);
      const actionResult = dispatch(actions.getInitialTeamTableSuccess(data));

      if (!teamIds.length) {
        return actionResult;
      }

      return dispatch(activityActions.getTeamsActivity({
        teamIds,
        since: activityUtils.xDaysAgo(activityConstants.CHARTS_DATA_PERIOD),
      }));
    })
    .catch((error) => {
      dispatch(actions.getInitialTeamTableFailure(error));
      throw error;
    });
};

export const updateTableOffset = (payload) => (dispatch) => {
  const offset = (payload - 1) * PAGINATION_LIMIT;
  dispatch(actions.saveTableOffset(payload));
  dispatch(teamsActions.getTeamList({ offset })).then(({ data }) => {
    const teamIds = data.results.map((team) => team.id);
    if (!teamIds.length) {
      return;
    }
    dispatch(activityActions.getTeamsActivity({
      teamIds,
      since: activityUtils.xDaysAgo(activityConstants.CHARTS_DATA_PERIOD),
    }));
  });
};

export const moveTeamUsers = (payload) => (dispatch) => {
  dispatch(actions.moveTeamUsersRequest());
  return api.moveTeamUsers(payload)
    .then(({ data }) => dispatch(actions.moveTeamUsersSuccess(data)))
    .catch((error) => {
      dispatch(notificationActions.notifyError('Couldn\'t move users to a new team'));
      dispatch(actions.moveTeamUsersFailure(error));
      throw error.response.data[0];
    });
};

// move users from [teamsId] into teamId on success remove [teamsId]
export const moveUsersBetweenTeams = (payload) => async (dispatch) => {
  const teamsToRemove = payload?.from?.toArray();
  const newTargetTeam = payload?.to;

  // eslint-disable-next-line no-restricted-syntax
  for (const teamId of teamsToRemove) {
    // eslint-disable-next-line no-await-in-loop
    await dispatch(moveTeamUsers({ from: teamId, to: newTargetTeam }));
  }
  dispatch(notificationActions.notifySuccess('Users moved into new team'));

  const removeTeamsBatch = teamsToRemove
    .map((teamId) => dispatch(teamsActions.removeTeam({ id: teamId }))
      .then(() => devicesOperations.removeDevicesInCookies({ id: teamId })));

  return Promise.all(removeTeamsBatch)
    .then(() => {
      dispatch(notificationActions.notifySuccess(
        `${removeTeamsBatch.length > 1 ? 'Teams' : 'Team'} removed and all respective devices are unassigned successfully`,
      ));
    })
    .catch((error) => {
      dispatch(notificationActions.notifyError(error.message));
    });
};
